import {Component, Input, OnDestroy, OnInit, ViewChild,} from '@angular/core';
import {FlatQuery, PowerSearchDashboardConfig, Query} from "../models/power-search.model";
import {FormBuilder} from "@angular/forms";
import {IPowerSearchState} from "../store/reducer/power-search.reducer";
import {select, Store} from "@ngrx/store";
import {getPowerSearchDashboardConfig} from "../store/selector/power-search.selector";
import {filter, takeUntil} from "rxjs/operators";
import {Subject} from "rxjs";
import {Router} from "@angular/router";

@Component({
    standalone: false,
    selector: 'particle-power-search-bar',
  templateUrl: './power-search-bar.component.html',
  styleUrls: ['./power-search-bar.component.scss']
})
export class PowerSearchBarComponent implements OnInit, OnDestroy {
  @Input() flatQueries : FlatQuery;
  queries : Query[];
  inputForm: any;
  componentRef : any;
  init$ : Subject<void>
  currentText: string;
  suggestions: Query[];
  powerSearchDashboardConfig$: any;
  ngUnsubscribe: Subject<void>;
  powerSearchConfig: any;
  query: Query = new Query();
  constructor(private formBuilder : FormBuilder,
              private powerSearchStore : Store<IPowerSearchState>,
              private router : Router) {
    this.init$ = new Subject<void>();
  }

  ngOnInit() {
    this.queries = [];
    this.ngUnsubscribe = new Subject<void>();
    this.inputForm = this.formBuilder.group({
      searchQuery : ['']
    });
    if(!this.flatQueries){
      this.flatQueries = new FlatQuery();
    }
    this.powerSearchDashboardConfig$ = this.powerSearchStore.pipe(select(getPowerSearchDashboardConfig), filter(val => val!=null && val!=undefined));
    this.powerSearchDashboardConfig$.pipe(takeUntil(this.ngUnsubscribe)).subscribe(state => {
      this.powerSearchConfig = state;
      this.getAllQueries(this.powerSearchConfig);
    });
    this.init$.subscribe(() => {
      this.suggestions = [];
      this.inputForm.valueChanges.subscribe(() => {
        if(this.inputForm.controls['searchQuery'].value){
          this.currentText = this.inputForm.controls['searchQuery'].value;
          let value = this.inputForm.controls['searchQuery'].value;
          this.suggestions = this.searchText(value.toLowerCase());
        }
      });
    });
    this.init$.next();
  }

  onFlatQueryClicked(index: number) {
    this.query = this.searchText(this.flatQueries.reports[index].displayQuery.toLowerCase())[0];
    this.inputForm.controls['searchQuery'].setValue(this.flatQueries.reports[index].displayQuery);
  }
  private getAllQueries(powerSearchConfig : PowerSearchDashboardConfig) {
    powerSearchConfig.powerQueries.forEach(powerQuery => {
      powerQuery.reports.forEach(report => {
        report.synonyms.forEach(synonym => {
          this.queries.push({
            group : powerQuery.group,
            displayQuery : synonym,
            powerQuery : report.powerQuery,
            id : powerQuery.id,
            reportId : report.id
          })
        });
      });
    });
  }


  private searchText(text: string) : Query[]{
    if(text.length==0)return [];
    let result = [];
    this.queries.forEach(queryObject => {
      if(queryObject.displayQuery.toLowerCase().includes(text)){
        result.push(queryObject);
      }
    });
    return result;
  }

  onClickedPowerSearch($event) {
    if(this.query.id.length>0) {
      this.init$.next();
      this.router.navigateByUrl("/home/" + this.query.id + "/" + this.query.reportId);
    }
  }

  onClickedSuggestion(suggestion: Query) {
    this.query = suggestion;
    this.inputForm.controls['searchQuery'].setValue(suggestion.displayQuery);
    console.log(this.query);
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
    this.init$.complete();
  }
}
